/* Use the approved PDP navigation for native Outdoor GreatRoom previews. */
if (!document.querySelector('[data-fire-standard]')) {
  const nav=document.createElement('nav');
  nav.className='hx27-nav ho-container';
  nav.dataset.ogcPdpNav='';
  nav.setAttribute('aria-label','Product sections');
  let signature='';
  function update(){
    const root=document.getElementById('outdoor-greatroom-root');
    const hero=root?.querySelector('#configure');
    if(!hero)return;
    if(hero.previousElementSibling!==nav)hero.before(nav);
    root.querySelectorAll('.detail-nav').forEach(old=>{old.hidden=true;});
    const warranty=[...root.querySelectorAll('[data-slot="accordion-trigger"]')].find(e=>e.textContent.trim()==='Care & warranty')?.closest('[data-slot="accordion-item"]');
    if(warranty)warranty.id='ogc-product-warranty';
    const choices=[['Overview','#configure'],['Product details','#details'],['Installation','#product-installation-video'],['Manuals & resources','#documents'],['Warranty','#ogc-product-warranty'],['Outdoor GreatRoom','#brand'],['Accessories','#accessories']];
    const links=choices.filter(([,selector])=>root.querySelector(selector));
    const key=JSON.stringify(links);
    if(key!==signature){signature=key;nav.replaceChildren(...links.map(([label,href])=>{const a=document.createElement('a');a.textContent=label;a.href=href;return a;}));}
  }
  nav.addEventListener('click',async event=>{
    const link=event.target.closest('a');if(!link)return;
    const target=document.getElementById(link.hash.slice(1));if(!target)return;
    event.preventDefault();
    const trigger=target.querySelector('[data-slot="accordion-trigger"][aria-expanded="false"]');
    if(trigger)trigger.click();
    const ancestor=target.closest('[data-slot="accordion-item"]');
    if(ancestor&&ancestor!==target)ancestor.querySelector('[data-slot="accordion-trigger"][aria-expanded="false"]')?.click();
    if(trigger||ancestor){
      await new Promise(resolve=>requestAnimationFrame(()=>requestAnimationFrame(resolve)));
      await Promise.allSettled(target.parentElement.getAnimations({subtree:true}).map(animation=>animation.finished));
    }
    const behavior=matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth';
    // Accordion layout and browser scroll anchoring can settle after the initial scroll.
    // Reconcile once at scroll end, unless the customer takes over scrolling.
    let cancelled=false;
    const cancel=()=>{cancelled=true;};
    window.addEventListener('wheel',cancel,{once:true,passive:true});
    window.addEventListener('touchstart',cancel,{once:true,passive:true});
    const settle=()=>{
      window.removeEventListener('wheel',cancel);
      window.removeEventListener('touchstart',cancel);
      const expected=parseFloat(getComputedStyle(target).scrollMarginTop)||0;
      if(!cancelled&&Math.abs(target.getBoundingClientRect().top-expected)>2)target.scrollIntoView({behavior,block:'start'});
    };
    if(trigger)window.addEventListener('scrollend',settle,{once:true});
    else {window.removeEventListener('wheel',cancel);window.removeEventListener('touchstart',cancel);}
    target.scrollIntoView({behavior,block:'start'});
  });
  update();
  new MutationObserver(update).observe(document.getElementById('MainContent'),{childList:true,subtree:true});
}
